let _ = t => t,
  _t;
import { Fragment, useState } from 'react';
import styled from 'styled-components';
import { EERIE, KOALA, OLAF } from 'HubStyleTokens/colors';
import { WEB_FONT_DEMI_BOLD_WEIGHT } from 'HubStyleTokens/misc';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { H3 } from 'UIComponents/elements/headings';
import * as tracker from '../_core/common/eventTracking/tracker';
import responsiveBreakpoints from '../_core/utils/responsiveBreakpoints';
import FeatureRow from './FeatureRow';
import { paddingLeft, rowHeaderStyles } from './sharedComponents';
import { filterFeaturesHiddenFromLang } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ExpandableSectionLabel = styled.tbody.withConfig({
  displayName: "ExpandableSection__ExpandableSectionLabel",
  componentId: "sc-1wpbphp-0"
})(["tr td:nth-child(1) div > div{background:red;width:100%;text-align:left;padding-top:8px;padding-bottom:8px;", " display:flex;align-items:flex-end;}"], paddingLeft);
export const ExpandableSectionContent = styled.tbody.withConfig({
  displayName: "ExpandableSection__ExpandableSectionContent",
  componentId: "sc-1wpbphp-1"
})(["position:relative;overflow:hidden;display:block;max-height:", ";transition:max-height 0.2s linear;&::after{visibility:", ";opacity:", ";position:absolute;bottom:0;height:100%;width:100%;content:'';background:", ";pointer-events:none;}& tr td{padding:16px 0;text-align:center;border:1px solid ", ";}& tr th[scope='row']{", "}tr:nth-child(n + ", "){display:", ";}"], props => props.isFeatureContentExpanded || props.hideFeatureContentExpandedButton ? '100%' : `${props.numberOfRowsToShow * 70}px`, props => props.isFeatureContentExpanded ? 'hidden' : 'visible', props => props.isFeatureContentExpanded ? 0 : 1, props => props.hideFeatureContentExpandedButton ? '' : `linear-gradient(to bottom, transparent 70%, ${OLAF})`, KOALA, rowHeaderStyles, props => props.numberOfRowsToShow + 1, props => props.hideFeatureContentExpandedButton ? 'none' : 'visible');
export const ExpandSectionButtonContainer = styled.tbody.withConfig({
  displayName: "ExpandableSection__ExpandSectionButtonContainer",
  componentId: "sc-1wpbphp-2"
})(["& tr td{padding-bottom:24px;padding-left:54px;", "}"], responsiveBreakpoints.tablet(_t || (_t = _`
      padding-left: 16px;
      `)));
const ExpandableSection = ({
  featureTableCategory,
  tableSharedData,
  id,
  showLabel = true,
  canViewNewSeats = false
}) => {
  const [isFeatureContentExpanded, setIsFeatureContentExpanded] = useState(featureTableCategory.alwaysExpanded || false);
  const {
    LabelContent
  } = featureTableCategory;
  const features = filterFeaturesHiddenFromLang(featureTableCategory.features);
  const {
    subscreen,
    levels
  } = tableSharedData;
  const numColumns = levels.length;
  const defaultNumberOfRowsToShow = 5;
  const hideFeatureContentExpandedButton = features.length <= defaultNumberOfRowsToShow;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [showLabel && /*#__PURE__*/_jsx(ExpandableSectionLabel, {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          colSpan: numColumns + 1,
          children: /*#__PURE__*/_jsx(H3, {
            style: {
              padding: '0 42px',
              marginBottom: 0,
              fontSize: 20,
              fontWeight: WEB_FONT_DEMI_BOLD_WEIGHT
            },
            children: LabelContent
          })
        })
      })
    }, `feature-table-${id}-section-label`), /*#__PURE__*/_jsx(ExpandableSectionContent, {
      "data-test-id": `feature-table-${id}-section-content`,
      className: isFeatureContentExpanded ? 'expanded' : 'collapsed',
      isFeatureContentExpanded: isFeatureContentExpanded,
      hideFeatureContentExpandedButton: hideFeatureContentExpandedButton,
      numberOfRowsToShow: defaultNumberOfRowsToShow,
      children: features.map(feature => {
        return /*#__PURE__*/_jsx(FeatureRow, {
          levels: levels,
          feature: feature,
          onlyShowCurrentLongLimit: featureTableCategory.onlyShowCurrentLongLimit || false,
          canViewNewSeats: canViewNewSeats
        }, feature.featureId);
      })
    }, `${id}-section-content`), !featureTableCategory.alwaysExpanded && /*#__PURE__*/_jsx(ExpandSectionButtonContainer, {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          colSpan: numColumns + 1,
          className: "display-flex align-center",
          children: !hideFeatureContentExpandedButton && /*#__PURE__*/_jsxs(UIButton, {
            use: "transparent",
            onClick: () => {
              tracker.track('featureTableInteraction', {
                action: `clicked-${isFeatureContentExpanded ? 'collapse' : 'expand'}-table`,
                subCategory: id,
                screen: subscreen
              });
              setIsFeatureContentExpanded(!isFeatureContentExpanded);
            },
            "aria-expanded": !!isFeatureContentExpanded,
            className: "p-left-0",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: isFeatureContentExpanded ? `upgrades.featureTable.body.collapse` : `upgrades.featureTable.body.expand`
            }), /*#__PURE__*/_jsx(UIIcon, {
              name: isFeatureContentExpanded ? 'up' : 'down',
              color: EERIE,
              size: "xxs"
            })]
          })
        })
      })
    }, `${id}-section-button-container`)]
  }, `${id}-section`);
};
export default ExpandableSection;